

export default {
    components: {},
    auth: false,
    data() {
        return {

        }
    },
    methods: {

    },

    mounted() {

    }
}
